import React from "react";
import AboutMeMobileCard from "./AboutMeMobileCard";
import SchoolIcon from "@mui/icons-material/School";
import TerminalIcon from "@mui/icons-material/Terminal";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import { motion } from "motion/react";

const AboutMeMobileView = () => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
      >
        <AboutMeMobileCard
          shift={false}
          content="Graduated from SLIIT in 2023"
          icon={
            <SchoolIcon
              style={{
                marginRight: "20px",
                color: "#155BDD",
                fontSize: "40px",
              }}
            />
          }
        />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
      >
        <AboutMeMobileCard
          shift={true}
          content="Undergraduate at University of Kelaniya (BICT)"
          icon={
            <SchoolIcon
              style={{ marginLeft: "20px", color: "#155BDD", fontSize: "40px" }}
            />
          }
        />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
      >
        <AboutMeMobileCard
          shift={false}
          content="Passionate in Web, Mobile and Games Development"
          icon={
            <TerminalIcon
              style={{
                marginRight: "20px",
                color: "#155BDD",
                fontSize: "40px",
              }}
            />
          }
        />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        whileInView={{ opacity: 1, scale: 1 }}
      >
        <AboutMeMobileCard
          shift={true}
          content="Prefered language is JavaScript/Typescript"
          icon={
            <WysiwygIcon
              style={{ marginLeft: "20px", color: "#155BDD", fontSize: "40px" }}
            />
          }
        />
      </motion.div>
    </div>
  );
};

export default AboutMeMobileView;
